export default "__VITE_ASSET__ChDcTuVk__";